import { useState } from 'react'

import { Typography } from '@material-ui/core'
import { NonDismissibleDialog } from '@scoir/modals'

import api from 'common/api'

import { DangerTextButton } from './LegacyButtons'

type UnregisterActionProps = {
  show: boolean
  onClose: () => void
  onEventChange: () => void
  eventId: string
}
const UnregisterAction = ({ show, onClose, onEventChange, eventId }: UnregisterActionProps) => {
  const [isConfirming, setIsConfirming] = useState(false)
  const [error, setError] = useState(false)
  const unregister = () => {
    setIsConfirming(true)
    api
      .delete(`/api/highschools/visits/${eventId}/register`)
      .then(() => {
        onEventChange()
        onClose()
        setIsConfirming(false)
        setError(false)
      })
      .catch(() => {
        setError(true)
        setIsConfirming(false)
      })
  }
  return (
    <NonDismissibleDialog
      open={show}
      headerText="Unregister from event"
      onClose={onClose}
    >
      <NonDismissibleDialog.Body>
        <span>
          Are you sure you want to unregister from this event? If you change your mind, you can register again.
        </span>
      </NonDismissibleDialog.Body>
      <NonDismissibleDialog.Footer>
        {error && (
          <Typography
            color="error"
            variant="body2"
          >
            An error occurred while attempting to unregister for this visit.
          </Typography>
        )}
        <NonDismissibleDialog.Footer.CloseButton>Cancel</NonDismissibleDialog.Footer.CloseButton>
        <NonDismissibleDialog.Footer.PrimaryActionButton
          disabled={isConfirming}
          onClick={() => unregister()}
        >
          Confirm
        </NonDismissibleDialog.Footer.PrimaryActionButton>
      </NonDismissibleDialog.Footer>
    </NonDismissibleDialog>
  )
}

const Trigger = ({ onOpen }: { onOpen: () => void }) => {
  return (
    <DangerTextButton
      variant="text"
      size="small"
      onClick={onOpen}
    >
      Unregister
    </DangerTextButton>
  )
}

// Table
UnregisterAction.Trigger = Trigger
export default UnregisterAction
